<app-nav></app-nav>
<main role="main">
   <router-outlet></router-outlet>
</main>
<app-footer class="footer"></app-footer>
<app-google-analytics-gtag *ngIf="analytics_key" [id]="analytics_key"></app-google-analytics-gtag>